import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Book, ShoppingCart, ExternalLink, Star, Quote } from 'lucide-react';

export const BookSales = () => {
  const books = [
    {
      id: 1,
      title: "Healing, Holy and Hood",
      subtitle: "A Black Woman's Survival Guide to Godly Love",
      description: "A powerful and authentic guide addressing faith, healing, and love from the perspective of Black women navigating spirituality and life's challenges. Nadja Scott offers wisdom, real talk, and godly guidance for finding true love while staying grounded in faith.",
      coverImage: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/we05zhsy_IMG_3839.jpeg",
      amazonLink: "https://www.amazon.com/Healing-Holy-Hood-Womans-Survival/dp/B0FQK4DWGR/ref=sr_1_1?dib=eyJ2IjoiMSJ9.mwEj8fADE80GjDB814dNiw.vq_Ci11ikjnOhJJc5EisGSObIDcDj1ZXNsSEdU5U43M&dib_tag=se&keywords=Healing+Holy+and+Hood+Nadja+Scott&qid=1760981547&sr=8-1"
    },
    {
      id: 2,
      title: "The Ministry Playbook",
      subtitle: "A Step-by-Step Guide to Thriving in the Gospel Music Industry",
      description: "Essential guidance for gospel artists, choir directors, and ministry leaders. Learn the insider strategies, practical wisdom, and spiritual principles needed to build a successful and sustainable gospel music ministry. From performance to business, this playbook covers it all.",
      coverImage: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/drbu1r76_IMG_3838.jpeg",
      amazonLink: "https://www.amazon.com/Ministry-Playbook-Step-Step-Thriving/dp/B0FRFXRJ6L/ref=sr_1_3?crid=W182UZSG2KIL&dib=eyJ2IjoiMSJ9.4PbmVEFWwWT0NCJq1FZ4nJL53p3n3dovqCOCZ9Q49ou5sZ6mRCBevypM8lidfKu5f95jHzqe6_RoEmEpyMaNU6-erIKn_TXB_4uxpaoAaJPFdduf-MZVSXTSMCLW-xjvjj2xRWfp4DINPwxbYKx_OLQ7H3rZOXZp1Dk1cwbYvHcBOwde2ZmO4d4vK25HapH5R_My0Qvq-8LII-wqSY1OSmfjorsabc9Q1ByGONzUL3g.SOFTuVbvx3ziJd9evlybnnuL7ENdFFTmpKoyBOW8hbk&dib_tag=se&keywords=nadja+scott&qid=1760981628&sprefix=nadja+scott%2Caps%2C244&sr=8-3"
    },
    {
      id: 3,
      title: "Girl Choirmaster",
      subtitle: "The Highs and Lows of a Girl Choirmaster",
      description: "An intimate memoir chronicling Nadja Scott's journey as a female choirmaster in a male-dominated field. Experience the triumphs, challenges, heartbreaks, and victories of leading a gospel choir with passion, excellence, and unwavering faith. A must-read for aspiring choir directors and ministry leaders.",
      coverImage: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/pp62ghae_61IsG6oYBWL._SL1499_.jpg",
      amazonLink: "https://www.amazon.com/Girl-Choirmaster-Highs-Lows/dp/B0FQJWRQH4/ref=sr_1_4?crid=W182UZSG2KIL&dib=eyJ2IjoiMSJ9.4PbmVEFWwWT0NCJq1FZ4nJL53p3n3dovqCOCZ9Q49ou5sZ6mRCBevypM8lidfKu5f95jHzqe6_RoEmEpyMaNU6-erIKn_TXB_4uxpaoAaJPFdduf-MZVSXTSMCLW-xjvjj2xRWfp4DINPwxbYKx_OLQ7H3rZOXZp1Dk1cwbYvHcBOwde2ZmO4d4vK25HapH5R_My0Qvq-8LII-wqSY1OSmfjorsabc9Q1ByGONzUL3g.SOFTuVbvx3ziJd9evlybnnuL7ENdFFTmpKoyBOW8hbk&dib_tag=se&keywords=nadja+scott&qid=1760981628&sprefix=nadja+scott%2Caps%2C244&sr=8-4"
    },
    {
      id: 4,
      title: "The Gift of Sarah",
      subtitle: "Finding Faith in the Barren Places",
      description: "A deeply moving exploration of faith during seasons of barrenness and waiting. Drawing from the biblical story of Sarah, Nadja Scott offers hope, encouragement, and practical wisdom for those navigating disappointment, delay, and divine timing. A must-read for anyone seeking God's promises in difficult seasons.",
      coverImage: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/3b98bgdq_61EaTBpmOGL._SY522_.jpg",
      amazonLink: "https://www.amazon.com/Gift-Sarah-Finding-Barren-Places/dp/B0FVT3VCN1?ref_=ast_author_dp&th=1&psc=1"
    },
    {
      id: 5,
      title: "The Weight of the Call",
      subtitle: "Lessons in Balancing Life and Ministry",
      description: "Coming Soon - November 2025. An honest and powerful look at balancing the demands of ministry with personal life, family, and self-care. Nadja Scott shares hard-won lessons about carrying the weight of the call without losing yourself in the process.",
      coverImage: "https://customer-assets.emergentagent.com/job_gospel-choir/artifacts/aikweo1j_KDP_PRINT_BOOK_CONVERTED_COVER_THUMBNAIL_100%20%281%29.png",
      amazonLink: null,
      comingSoon: true
    }
  ];

  return (
    <section id="books" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-6">
            <Book className="w-12 h-12 text-red-600 mr-4" />
            <h2 className="text-4xl md:text-6xl font-bold text-white">
              Nadja Scott the Author
            </h2>
          </div>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Beyond her musical ministry, Nadja Scott is an accomplished author, sharing her wisdom, 
            experiences, and spiritual insights through powerful written works that inspire and educate.
          </p>
        </div>

        {/* Author Bio */}
        <div className="bg-gradient-to-br from-red-600/20 to-black rounded-3xl p-8 md:p-12 mb-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">About the Author</h3>
              <p className="text-gray-300 text-lg leading-relaxed mb-6">
                Nadja Scott brings over 15 years of ministry experience to her writing, combining 
                practical wisdom with spiritual insight. As Head Choirmaster and founder of Divine Anointing, 
                she has witnessed countless transformations through the power of gospel music.
              </p>
              <p className="text-gray-300 text-lg leading-relaxed">
                Her books reflect her passion for developing leaders, empowering voices, and sharing 
                the life-changing message of faith through both music and written word.
              </p>
            </div>
            <div className="text-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/cxl0ff1u_IMG_4098.jpeg"
                alt="Nadja Scott - Author and Ministry Leader"
                className="w-64 h-64 object-cover object-top rounded-full mx-auto shadow-2xl border-4 border-red-600"
              />
              <p className="text-white font-bold text-xl mt-4">Nadja Scott</p>
              <p className="text-red-400 text-lg">Author & Ministry Leader</p>
            </div>
          </div>
        </div>

        {/* Books Collection */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {books.map((book) => (
            <Card key={book.id} className="bg-gray-900 border border-gray-700 overflow-hidden hover:shadow-2xl transition-all">
              <CardContent className="p-0">
                {/* Book Cover */}
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img 
                    src={book.coverImage}
                    alt={book.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>

                {/* Book Details */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2">{book.title}</h3>
                  <h4 className="text-lg text-red-400 mb-4">{book.subtitle}</h4>
                  
                  <p className="text-gray-300 text-sm leading-relaxed mb-6">
                    {book.description}
                  </p>

                  {/* Buy Button */}
                  {book.comingSoon ? (
                    <div className="w-full bg-gray-700 text-white px-4 py-3 rounded-lg text-center font-semibold">
                      Coming Soon - November 2025
                    </div>
                  ) : (
                    <a
                      href={book.amazonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full"
                    >
                      <Button className="w-full bg-red-600 hover:bg-red-700 text-white flex items-center justify-center gap-2">
                        <ShoppingCart className="w-4 h-4" />
                        Buy on Amazon
                        <ExternalLink className="w-3 h-3" />
                      </Button>
                    </a>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Author Note */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-br from-red-600/20 to-black rounded-3xl p-8 md:p-12">
            <Book className="w-16 h-16 text-red-600 mx-auto mb-6" />
            <h3 className="text-3xl font-bold text-white mb-4">Transform Your Life Through Faith</h3>
            <p className="text-gray-300 text-lg mb-6 max-w-2xl mx-auto">
              Each book by Nadja Scott offers authentic wisdom, practical guidance, and spiritual insight drawn from years of ministry experience. Whether you're seeking healing, building a ministry, or navigating leadership, these books will inspire and empower your journey.
            </p>
            <a 
              href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full text-lg">
                Connect with Nadja Scott
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};